import { render } from "./UrseniView.vue?vue&type=template&id=6ec9ee84"
const script = {}

import "./UrseniView.vue?vue&type=style&index=0&id=6ec9ee84&lang=css"

import exportComponent from "D:\\Backup\\Sunville\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__